import React from 'react';
import { Route, Routes } from 'react-router-dom';
import QuatreBisHome from './Home';

function Router() {
  return (
    <Routes>
      <Route exact path="/quatrebis/home" element={<QuatreBisHome />} />
    </Routes>
  );
}

export default Router;
